<template>
    <div class="booking-detail">
        <div class="flex flex-y-center flex-between mb-30">
            <div class="font30 c666 title">预约项目</div>
            <div class="font30 c333">2023美白季[瘦身]护理套餐(A+B)</div>
        </div>
        <div class="flex flex-y-center flex-start font26 c999 border">
            <div class="title-sm">权益明细：</div>
            <div>680元护理*1，980元护理*1，1380护理*1</div>
        </div>
        <div class="flex flex-y-center flex-between border pt-30">
            <div class="font30 c666 ">预约人姓名</div>
            <div class="font30 c333">郑小小备份</div>
        </div>
        <div class="flex flex-y-center flex-between border pt-30">
            <div class="font30 c666 ">性别</div>
            <div class="font30 c333">女</div>
        </div>
        <div class="flex flex-y-center flex-between border pt-30">
            <div class="font30 c666 ">手机号码</div>
            <div class="font30 c333">12918811991</div>
        </div>
        <div class="flex flex-y-center flex-between border pt-30">
            <div class="font30 c666 ">护理要求</div>
            <div class="font30 c333">面部护理</div>
        </div>
        <div class="btn">
            确认
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { setCookie, getCookie } from "@/utils";
import request from "@/utils/request";


export default {
    name: "bookingDetail",
    data() {
        return {

        };
    },
    created() {
        this.onLoad();
    },
    methods: {
        //员工基本信息
        onLoad() {
            return request({
                url: '/my/getUserLogin',
                method: "get",
            })
                .then((res) => {
                    setCookie("toDoNum", res.data.backlog);
                    setCookie("empNo", res.data.empNo);
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                });
        },

    },
};
</script>

<style lang="less" scoped>
.booking-detail {
    padding: 30px;
    height: 100vh;
}
.c333 {
    color: #333;
}
.c666 {
    color: #666;
}
.c999 {
    color: #999;
}
.border {
    padding-bottom: 30px;
    border-bottom: 1px solid #d7d7d7;
}
.title {
    width: 124px;
}
.title-sm {
    width: 150px;
}
.pt-30 {
    padding-top: 30px;
}
.btn {
    width: 630px;
    height: 88px;
    background: #333f48;
    border-radius: 44px;
    line-height: 88px;
    color: #ffffff;
    font-size: 32px;
    text-align: center;
    margin: 0 auto;
    margin-top: 439px;
}
</style>
